/**
 * @fileoverview added by tsickle
 * Generated from: models/job.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { jobModelMixin } from './job.mixin';
/** @enum {string} */
var JobState = {
    Cancelled: "x",
    Confirmed: "c",
};
export { JobState };
/** @enum {string} */
var JobType = {
    StandardClean: "standard_clean",
    SpecialistClean: "specialist_clean",
    Tradespeople: "tradespeople",
};
export { JobType };
/**
 * Base model for a job, containing all relevant fields returned by the API.
 * @record
 */
function BaseJobModel() { }
if (false) {
    /** @type {?} */
    BaseJobModel.prototype.id;
    /** @type {?} */
    BaseJobModel.prototype.access;
    /** @type {?} */
    BaseJobModel.prototype.accessOverride;
    /** @type {?} */
    BaseJobModel.prototype.accountId;
    /** @type {?} */
    BaseJobModel.prototype.anyWorker;
    /** @type {?} */
    BaseJobModel.prototype.baseDate;
    /** @type {?} */
    BaseJobModel.prototype.endDate;
    /** @type {?} */
    BaseJobModel.prototype.isHomeClean;
    /** @type {?} */
    BaseJobModel.prototype.isSpecialistClean;
    /** @type {?} */
    BaseJobModel.prototype.isTradespeople;
    /** @type {?} */
    BaseJobModel.prototype.jobState;
    /** @type {?} */
    BaseJobModel.prototype.timeSlot;
    /** @type {?} */
    BaseJobModel.prototype.timeSlotAnyTimeSwitchDate;
    /** @type {?} */
    BaseJobModel.prototype.tasks;
    /** @type {?} */
    BaseJobModel.prototype.nextVisitDate;
    /** @type {?} */
    BaseJobModel.prototype.propertyId;
    /** @type {?} */
    BaseJobModel.prototype.jobType;
    /** @type {?|undefined} */
    BaseJobModel.prototype.isWithinExtraJobsSignal;
}
/**
 * Optional expandable fields that can be requested from the API.
 * @record
 */
function JobExpandables() { }
if (false) {
    /** @type {?|undefined} */
    JobExpandables.prototype.account;
    /** @type {?|undefined} */
    JobExpandables.prototype.property;
    /** @type {?|undefined} */
    JobExpandables.prototype.workers;
    /** @type {?|undefined} */
    JobExpandables.prototype.totalUpcomingCustomerSkips;
    /** @type {?|undefined} */
    JobExpandables.prototype.totalPreviousConsecutiveCustomerSkips;
    /** @type {?|undefined} */
    JobExpandables.prototype.customerUpcomingSkipLimit;
    /** @type {?|undefined} */
    JobExpandables.prototype.customerConsecutiveSkipLimit;
    /** @type {?|undefined} */
    JobExpandables.prototype.lastVisitDate;
}
/**
 * Model representing a job.
 * @record
 */
export function Job() { }
/** @type {?} */
export var job = jobModelMixin.extend((/** @type {?} */ ({
    modelName: 'job'
})));
